export default __webpack_public_path__ + "static/media/wave.7898b914.svg";